import { render } from "./InternalOrderCancerProjectOverview.vue?vue&type=template&id=c3347122"
import script from "./InternalOrderCancerProjectOverview.vue?vue&type=script&lang=js"
export * from "./InternalOrderCancerProjectOverview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__